module.exports = __webpack_public_path__ + "img/wallet_02_nft_1.2597576c.png";